import { observer } from 'mobx-react';
import * as React from 'react';
import { DragHandleProps } from '../../../../../../../../Draggable/Types';
import DragIndicatorIcon from '../../../../../../../Cutesies/DragIndicatorIcon';
import { ExperienceResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import ExperienceRowItems from './ExperienceRowItems';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
  experienceResource: ExperienceResource;
  dragHandleProps: DragHandleProps;
}

const ExperienceRowItemsWithHandlers: React.FC<Props> = ({
  context,
  store,
  experienceResource,
  dragHandleProps,
}) => {
  return (
    <div className="pt-1 w-full flex items-center">
      <input
        className="h-5 w-4 cursor-pointer text-teal-600"
        type="checkbox"
        name="modifyExperience"
        checked={true}
        onChange={() => store.removeExperienceStore(context, experienceResource)}
      />
      <td className="px-2 pt-1">
        <div className="inline-block cursor-grab" {...dragHandleProps}>
          <DragIndicatorIcon />
        </div>
      </td>
      <ExperienceRowItems experienceResource={experienceResource} />
    </div>
  );
};

export default observer(ExperienceRowItemsWithHandlers);
